import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dimensions, Image, Modal, Platform, StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import FormatService from '../../lib/format';
import theme from '../../theme-config';
import FullButton from './FullButtons/FullButton';
import I18n from '../../lib/i18n';

type Props = {
};


class FreeTrialModal extends Component<Props> {

  styles = getStyles();

  state = {
    showModal: true,
  };

  onModalRequestClose = () => {
    this.setState(state => ({
      showModal: !state.showModal,
    }));
  };

  onModalButtonPress = () => {
    this.setState(state => ({
      showModal: !state.showModal,
    }));
  };

  render() {
    const { styles } = this;

    return (
      <Modal
        visible={this.state.showModal}
        style={styles.container}
        animationType="slide"
        transparent={true}
        accessible={true}
        onRequestClose={this.onModalRequestClose}>
        <View style={styles.background}>
          <View style={styles.content}>
            <Image source={theme.giftImage} style={styles.image} />
            <Text style={styles.title1}>
              {I18n.t('promotion.FREE_TRIAL.title1')}              
            </Text>
            <Text style={styles.title2}>
              {I18n.t('promotion.FREE_TRIAL.title2')}              
            </Text>
            <Text style={styles.textDetail}>
              {I18n.t('promotion.FREE_TRIAL.detail')}              
            </Text>
            <FullButton
              style={{ width: 200 }}
              text={I18n.t('promotion.FREE_TRIAL.buttonText1')}              
              onPress={this.onModalButtonPress}
              disabled={false}
            />
          </View>
        </View>
      </Modal>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: 150,
      height: 150,
      marginBottom: 10,
      resizeMode: 'cover',
    },
    title1: {
      color: theme.secondaryColor,
      fontWeight: 'bold',
      fontSize: Platform.select({ ios: 16, android: 14 }),
      marginBottom: 10,
      marginTop: 20,
    },
    title2: {
      color: theme.primaryColor,
      fontWeight: 'bold',
      fontSize: Platform.select({ ios: 23, android: 20 }),
      marginBottom: 10,
    },
    textDetail: {
      color: theme.gray.normalLight,
      marginBottom: 20,
      marginHorizontal: 10,
      textAlign: 'justify',
    },
    background: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      width: Platform.select({ ios: 350, android: 300 }),
      padding: 20,
      backgroundColor: 'white',
      borderRadius: 10,
      alignItems: 'center',
    },
  });
}

export default FreeTrialModal;
